module.exports = __webpack_public_path__ + "img/20190529112624微信截图_20190529113025.f878b8ed.png";